// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/javascript/components/frags/ScopeList/styles.scss
// module id = 377
// module chunks = 0 1